<div data-testid="wrong-region" class="h-dvh w-dvw bg-shui-base-1 flex flex-col p-8 box-border">
    <img
        src="assets/images/healthineers-logo/healthineers-logo-black.svg"
        alt="Siemens Healthineers"
        class="w-32 self-start shrink-0 [html[theme='dark']_&]:hidden"
    />
    <img
        src="assets/images/healthineers-logo/healthineers-logo-white.svg"
        alt="Siemens Healthineers"
        class="w-32 self-start shrink-0 hidden [html[theme='dark']_&]:block"
    />

    <div class="flex-1 flex items-center justify-center">
        <div class="flex flex-col items-center text-center gap-6 max-w-[520px] pb-[10vh]">
            <div class="flex h-20 w-20 items-center justify-center rounded-full bg-shui-base-3">
                <sh-icon icon="region-language" size="l" class="text-shui-text-subtle"></sh-icon>
            </div>

            <div class="flex flex-col gap-3">
                <h1 class="m-0 text-2xl font-bold font-sh-bree-headline text-shui-text-strong">
                    {{ 'common.wrong-region.title' | translate }}
                </h1>

                <p class="m-0 text-sm text-shui-text-moderate">
                    {{ 'common.wrong-region.description' | translate: { region: regionLabel() } }}
                </p>
            </div>

            <a [href]="regionUrl()" data-testid="wrong-region-link" class="no-underline">
                <sh-button
                    [label]="'common.wrong-region.action' | translate: { region: regionLabel() }"
                    layout="normal"
                    color="primary"
                    size="max-content"
                ></sh-button>
            </a>

            <p class="m-0 text-sm text-shui-text-subtle">
                {{ 'common.wrong-region.hint' | translate }}
            </p>
        </div>
    </div>
</div>
